import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const bold = css`
  font-weight: ${typography.weightBold};
  white-space: pre-wrap;
`;

export const regular = css`
  white-space: pre-wrap;
`;
